export default {
    setainushi: {
        18:1.8,
        19:1.8,
        20:1.8,
        21:1.8,
        22:1.8,
        23:1.8,
        24:1.8,
        25:1.8,
        26:1.8,
        27:1.8,
        28:1.8,
        29:1.8,
        30:1.8,
        31:1.8,
        32:1.8,
        33:1.8,
        34:1.8,
        35:1.8,
        36:1.8,
        37:1.8,
        38:1.8,
        39:1.8,
        40:1.2,
        41:1.2,
        42:1.2,
        43:1.2,
        44:1.2,
        45:1.2,
        46:1.2,
        47:1.2,
        48:1.2,
        49:1.2,
        50:1.5,
        51:1.5,
        52:1.5,
        53:1.5,
        54:1.5,
        55:1.5,
        56:1.5,
        57:1.5,
        58:1.5,
        59:1.5,
        60:1.5,
        61:1.5,
        62:1.5,
        63:1.5,
        64:1.5,
        65:1.5,
        66:1.5,
        67:1.5,
        68:1.5,
        69:1.5,
        70:1.5,
        71:1.5,
        72:1.5,
        73:1.5,
        74:1.5,
        75:1.5,
        76:1.5,
        77:1.5,
        78:1.5,
        79:1.5,
        80:1.5,
        81:1.5,
        82:1.5,
        83:1.5,
        84:1.5,
        85:1.5,
        86:1.5,
        87:1.5,
        88:1.5,
        89:1.5,
        90:1.5,
    },
    haiguusha: {
        18:1.8,
        19:1.8,
        20:1.8,
        21:1.8,
        22:1.8,
        23:1.8,
        24:1.8,
        25:1.8,
        26:1.8,
        27:1.8,
        28:1.8,
        29:1.8,
        30:1.8,
        31:1.8,
        32:1.8,
        33:1.8,
        34:1.8,
        35:1.8,
        36:1.8,
        37:1.8,
        38:1.8,
        39:1.8,
        40:1.2,
        41:1.2,
        42:1.2,
        43:1.2,
        44:1.2,
        45:1.2,
        46:1.2,
        47:1.2,
        48:1.2,
        49:1.2,
        50:1.5,
        51:1.5,
        52:1.5,
        53:1.5,
        54:1.5,
        55:1.5,
        56:1.5,
        57:1.5,
        58:1.5,
        59:1.5,
        60:1.5,
        61:1.5,
        62:1.5,
        63:1.5,
        64:1.5,
        65:1.5,
        66:1.5,
        67:1.5,
        68:1.5,
        69:1.5,
        70:1.5,
        71:1.5,
        72:1.5,
        73:1.5,
        74:1.5,
        75:1.5,
        76:1.5,
        77:1.5,
        78:1.5,
        79:1.5,
        80:1.5,
        81:1.5,
        82:1.5,
        83:1.5,
        84:1.5,
        85:1.5,
        86:1.5,
        87:1.5,
        88:1.5,
        89:1.5,
        90:1.5,

    }
}